import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import Alert from '../../components/Alert';
import { getEnterpriseCurrentStrategy } from '../../api/admin';

export default function AdminEnterpriseStrategyPage() {
  const [strategy, setStrategy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getEnterpriseCurrentStrategy()
      .then(({ data }) => setStrategy(data))
      .catch(e => setError(e.response?.data?.detail || '加载失败'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="当前 AI 策略">
      {error && <Alert type="error">{error}</Alert>}
      {loading ? (
        <p style={{ color: '#94a3b8' }}>加载中...</p>
      ) : strategy ? (
        <div style={{ maxWidth: 560 }}>
          {/* 策略卡片 */}
          <div style={{
            background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0',
            padding: '28px 32px', marginBottom: 20,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
              <div style={{
                width: 44, height: 44, borderRadius: 10, background: '#eff6ff',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
              }}>⚙️</div>
              <div>
                <p style={{ fontSize: 11, color: '#94a3b8', marginBottom: 2 }}>当前生效 AI 策略</p>
                <p style={{ fontSize: 18, fontWeight: 700, color: '#1a3a6b' }}>{strategy.name}</p>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
              <InfoItem label="版本号" value={`v${strategy.version}`} />
              <InfoItem
                label="策略来源"
                value={strategy.is_enterprise_specific ? '企业专属' : '平台默认'}
                valueColor={strategy.is_enterprise_specific ? '#2563eb' : '#64748b'}
              />
              <InfoItem
                label="是否全局默认"
                value={strategy.is_default ? '是' : '否'}
                valueColor={strategy.is_default ? '#16a34a' : '#94a3b8'}
              />
            </div>
          </div>

          <div style={{
            background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0',
            padding: '16px 20px', fontSize: 13, color: '#64748b', lineHeight: 1.7,
          }}>
            <p style={{ fontWeight: 600, color: '#475569', marginBottom: 6 }}>说明</p>
            <p>以上信息为本企业当前生效的 AI 出题策略，由平台管理员统一配置。策略决定了：</p>
            <ul style={{ paddingLeft: 18, margin: '8px 0 0' }}>
              <li>AI 如何根据用户画像动态选题</li>
              <li>多选题的评分规则（全对给分 / 按比例给分）</li>
              <li>难度自适应调节参数</li>
              <li>报告生成的 AI 提示词风格</li>
            </ul>
            <p style={{ marginTop: 8 }}>如需调整策略，请联系平台系统管理员。</p>
          </div>
        </div>
      ) : null}
    </AdminLayout>
  );
}

function InfoItem({ label, value, valueColor }) {
  return (
    <div>
      <p style={{ fontSize: 11, color: '#94a3b8', marginBottom: 3 }}>{label}</p>
      <p style={{ fontSize: 15, fontWeight: 600, color: valueColor || '#1e293b' }}>{value}</p>
    </div>
  );
}
